import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
import { computed } from "vue";
import { secondsToDisplay } from "@/utils/util";
import { useOverviewThresholdSettingStore } from "@/store/pinia/useOverviewThresholdSettingStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChildTimeTableCell',
    props: {
        loadedOverviewItems: {},
        node: {},
        intervalId: {},
        field: {},
        hasBorderBottom: { type: Boolean },
        headerLabelsBeforeToday: {}
    },
    setup(__props) {
        const props = __props;
        const timeInterval = computed(() => {
            return props.node.timeIntervalValues.find((timeInterval) => timeInterval.id === props.intervalId);
        });
        const isWorkingDay = computed(() => {
            // Find the parent employee that contains this child
            const parentEmployee = props.loadedOverviewItems?.find((employee) => employee.children.some((child) => child.key === props.node.key));
            if (!parentEmployee) {
                return false;
            }
            return (parentEmployee.timeIntervalValues.find((timeInterval) => timeInterval.id === props.intervalId)?.["workScheduleTime"] > 0);
        });
        const isWeekendOrHoliday = computed(() => {
            return !isWorkingDay.value && (timeInterval.value?.[props.field] ?? 0) === 0;
        });
        const projectThresholdInSeconds = computed(() => {
            return projectThreshold.value * 3600;
        });
        const getTimeValue = () => {
            if (!timeInterval.value)
                return {
                    value: "0:00",
                    isLoggedTimeAndSecondsAreNull: false,
                };
            const seconds = timeInterval.value[props.field];
            const isLoggedTimeAndSecondsAreNull = props.field === "loggedTime" && seconds === null;
            return {
                value: secondsToDisplay(seconds),
                isLoggedTimeAndSecondsAreNull,
            };
        };
        const getClasses = (node, intervalId, field) => {
            const weekendOrHolidayColor = "!bg-surface-50 dark:!bg-surface-0 !border-surface-100";
            const secondarySuccessColor = "!bg-surface-0 !border-surface-100 !text-emerald-500";
            const dangerColor = "bg-red-50 dark:bg-red-950 border-surface-100 !text-red-500";
            const greyColor = "bg-surface-0 border-surface-100 !text-surface-300";
            const allocatedTime = timeInterval.value?.allocatedTime ?? 0;
            const loggedTime = timeInterval.value?.loggedTime ?? 0;
            // If not a working day and the field value is 0, return the weekend or holiday color
            if (isWeekendOrHoliday.value)
                return weekendOrHolidayColor;
            // If the date is in the future, and there is logged time, colorize as danger
            if (!colorizeEnabled() &&
                field === "loggedTime" &&
                loggedTime > 0 + projectThresholdInSeconds.value)
                return dangerColor;
            // If the date is in the future, and the allocation time is 0, colorize as grey
            if (!colorizeEnabled() &&
                ["allocatedTime", "loggedTime"].includes(field) &&
                allocatedTime === 0)
                return greyColor;
            // If the date is in the future, and the allocation time greater than 0, colorize as grey
            if (!colorizeEnabled() &&
                ["allocatedTime"].includes(field) &&
                allocatedTime > 0)
                return "font-semibold";
            // Turn off colorization filds in the future
            if (!colorizeEnabled())
                return "";
            switch (field) {
                case "loggedTime":
                    if (
                    // allocatedTime === loggedTime ||
                    // (loggedTime === null && allocatedTime === 0)
                    loggedTime <= allocatedTime + projectThresholdInSeconds.value &&
                        loggedTime >= allocatedTime - projectThresholdInSeconds.value) {
                        return secondarySuccessColor;
                    }
                    else if (allocatedTime !== loggedTime)
                        return dangerColor;
                    else
                        return "";
                case "allocatedTime":
                    return "font-semibold";
                default:
                    return "";
            }
        };
        const colorizeEnabled = () => {
            const headerLabelsBeforeToday = props.headerLabelsBeforeToday;
            const timeInterval = props.node.timeIntervalValues.find((timeInterval) => timeInterval.id === props.intervalId);
            if (!timeInterval)
                return false;
            return headerLabelsBeforeToday?.includes(timeInterval.id);
        };
        // Threshold settings
        const overviewThresholdSettingStore = useOverviewThresholdSettingStore();
        const projectThreshold = computed(() => {
            return overviewThresholdSettingStore.projectLoggedTimeComplianceErrorThreshold;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["min-w-[100px] h-[29px] flex items-center justify-center border-surface-100 text-surface-950 text-sm font-normal border-r", [
                        getClasses(__props.node, __props.intervalId, __props.field),
                        { 'border-b': __props.hasBorderBottom },
                    ]])
            }, [
                (!isWeekendOrHoliday.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(getTimeValue().value), 1))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
